// Стрелочка-«хвостик» у всплывающих карточек (подсказки Hint, перевод по
// наведению, тултип кнопки-репетитора) — просьба пользователя 2026-09-18:
// окна со стрелкой к элементу читаются лучше. Повёрнутый квадрат с двумя
// сторонами рамки; цвет — тот край градиента карточки, к которому он примыкает.
export type PopoverSide = 'top' | 'bottom'

// fill - заливка уголка, если у карточки сплошной фон, а не градиент.
export function PopoverArrow({ x, side, border, fill }: { x: number; side: PopoverSide; border: string; fill?: string }) {
  // side = 'top' — карточка стоит под элементом, стрелка смотрит вверх.
  const up = side === 'top'
  return (
    <span
      aria-hidden
      style={{
        position: 'absolute',
        left: x - 6,
        top: up ? -7 : undefined,
        bottom: up ? undefined : -7,
        width: 12,
        height: 12,
        transform: 'rotate(45deg)',
        background: fill ?? (up ? 'oklch(0.27 0.05 254)' : 'oklch(0.165 0.035 254)'),
        borderTop: up ? `1px solid ${border}` : undefined,
        borderLeft: up ? `1px solid ${border}` : undefined,
        borderBottom: up ? undefined : `1px solid ${border}`,
        borderRight: up ? undefined : `1px solid ${border}`,
        borderRadius: 2,
        pointerEvents: 'none',
      }}
    />
  )
}

// Позиция карточки относительно элемента: под ним, если хватает места, иначе
// над ним; по горизонтали — в пределах экрана. Возвращает и точку стрелки.
// Масштаб текста из настроек = zoom на <html>; 1, если не задан.
export function htmlZoom(): number {
  return Number(getComputedStyle(document.documentElement).zoom) || 1
}

export function placePopover(
  rawRect: { left: number; top: number; bottom: number; width: number },
  w: number,
  h: number,
  gap: number,
): { left: number; top: number; arrowX: number; side: PopoverSide } {
  // Размер текста в настройках — это zoom на <html>: getBoundingClientRect и
  // innerWidth/innerHeight в экранных px, а position: fixed внутри zoom — в
  // CSS px. Без пересчёта карточка уезжала вниз и обрезалась.
  const zoom = htmlZoom()
  const rect = { left: rawRect.left / zoom, top: rawRect.top / zoom, bottom: rawRect.bottom / zoom, width: rawRect.width / zoom }
  const vw = window.innerWidth / zoom
  const vh = window.innerHeight / zoom
  let left = rect.left + rect.width / 2 - w / 2
  left = Math.max(12, Math.min(left, vw - w - 12))
  const below = rect.bottom + gap
  const fitsBelow = below + h <= vh - 8
  const fitsAbove = rect.top - h - gap >= 8
  const above = !fitsBelow && fitsAbove
  let top = above ? rect.top - h - gap : below
  // Не помещается ни там, ни там — прижимаем к краю экрана, но не режем.
  if (!fitsBelow && !fitsAbove) top = Math.max(8, vh - h - 8)
  const arrowX = Math.max(16, Math.min(rect.left + rect.width / 2 - left, w - 16))
  return { left, top, arrowX, side: above ? 'bottom' : 'top' }
}
